import { defineStore } from 'pinia';
import MetaCampaignsAdAccountsAPI from 'dashboard/api/metaCampaignsAdAccounts';

export const useMetaCampaignsAdAccountsStore = defineStore(
  'metaCampaignsAdAccounts',
  {
    state: () => ({
      records: [],
      uiFlags: {
        fetchingList: false,
        connecting: false,
        disconnecting: false,
        reconnecting: false,
        syncing: false,
        backfilling: false,
      },
    }),

    getters: {
      getAdAccounts: state => state.records,
    },

    actions: {
      async fetch() {
        this.uiFlags.fetchingList = true;
        try {
          const { data } = await MetaCampaignsAdAccountsAPI.get();
          this.records = data;
        } finally {
          this.uiFlags.fetchingList = false;
        }
      },

      async oauthAdAccounts(shortLivedToken) {
        const { data } =
          await MetaCampaignsAdAccountsAPI.oauthAdAccounts(shortLivedToken);
        return data;
      },

      async lookupAdAccounts(accessToken) {
        const { data } =
          await MetaCampaignsAdAccountsAPI.lookupAdAccounts(accessToken);
        return data;
      },

      async connect(payload) {
        this.uiFlags.connecting = true;
        try {
          const { data } = await MetaCampaignsAdAccountsAPI.create({
            ad_account: payload,
          });
          this.records.push(data);
          return data;
        } finally {
          this.uiFlags.connecting = false;
        }
      },

      async disconnect(id) {
        this.uiFlags.disconnecting = true;
        try {
          await MetaCampaignsAdAccountsAPI.delete(id);
          this.records = this.records.filter(record => record.id !== id);
        } finally {
          this.uiFlags.disconnecting = false;
        }
      },

      async reconnect(id, accessToken) {
        this.uiFlags.reconnecting = true;
        try {
          const { data } = await MetaCampaignsAdAccountsAPI.reconnect(
            id,
            accessToken
          );
          this.records = this.records.map(record =>
            record.id === id ? data : record
          );
          return data;
        } finally {
          this.uiFlags.reconnecting = false;
        }
      },

      async syncNow(id) {
        this.uiFlags.syncing = true;
        try {
          const { data } = await MetaCampaignsAdAccountsAPI.sync(id);
          this.records = this.records.map(record =>
            record.id === id ? data : record
          );
          return data;
        } finally {
          this.uiFlags.syncing = false;
        }
      },

      async backfill(id, since, until) {
        this.uiFlags.backfilling = true;
        try {
          const { data } = await MetaCampaignsAdAccountsAPI.backfill(
            id,
            since,
            until
          );
          this.records = this.records.map(record =>
            record.id === id ? data : record
          );
          return data;
        } finally {
          this.uiFlags.backfilling = false;
        }
      },
    },
  }
);
